export default __webpack_public_path__ + "static/media/listening-to-your-body.a8a7d542.svg";